import React, { useState, useEffect } from "react";
import {
  getStudentIdData,
  addData,
  updateData,
} from "../../../lib/studentbragsheet";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../usercontext";

export default function GlobalBragSheet({ slug }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [grade, setGrade] = useState("");
  const [deadline, setDeadline] = useState("");
  const [testScore, setTestScore] = useState("");
  const [extActivity, setExtActivity] = useState("");
  const [award, setAward] = useState("");
  const [threeAdjective, setThreeAdjective] = useState("");
  const [hobby, setHobby] = useState("");
  const [mostProud, setMostProud] = useState("");
  const [strengWeakness, setStrengWeakness] = useState("");
  const [obstacle, setObstacle] = useState("");
  const [recommendation, setRecommendation] = useState("");
  const [recId, setRecId] = useState(0);
  const [showMessage, setShowMessage] = useState(false);
  const navigate = useNavigate();

  async function GetData() {
    const data = await getStudentIdData(slug);
    console.log("data", data);
    if (data.length > 0) {
      setRecId(data[0].id);
      setName(data[0].name);
      setEmail(data[0].email);
      setGrade(data[0].grade);
      setDeadline(data[0].deadline);
      setTestScore(data[0].testScore);
      setExtActivity(data[0].extActivity);
      setAward(data[0].award);
      setThreeAdjective(data[0].threeAdjective);
      setHobby(data[0].hobby);
      setMostProud(data[0].mostProud);
      setStrengWeakness(data[0].strengWeakness);
      setObstacle(data[0].obstacle);
      setRecommendation(data[0].recommendation);
    }
    setShowMessage(false);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    //if is recId update else insert
    if (recId > 0) {
      await updateData({
        id: recId,
        studentId: slug,
        name: name,
        email: email,
        grade: grade,
        deadline: deadline,
        testScore: testScore,
        extActivity: extActivity,
        award: award,
        threeAdjective: threeAdjective,
        hobby: hobby,
        mostProud: mostProud,
        strengWeakness: strengWeakness,
        obstacle: obstacle,
        recommendation: recommendation,
      });
    } else {
      await addData({
        studentId: slug,
        name: name,
        email: email,
        grade: grade,
        deadline: deadline,
        testScore: testScore,
        extActivity: extActivity,
        award: award,
        threeAdjective: threeAdjective,
        hobby: hobby,
        mostProud: mostProud,
        strengWeakness: strengWeakness,
        obstacle: obstacle,
        recommendation: recommendation,
      });
    }

    setShowMessage(true);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    GetData();
  }, [slug]);

  return (
    <div className="p-2 bg-white rounded shadow-sm">
      {/* <div className="container mt-1"> */}
      {showMessage && (
        <div
          className="alert alert-success alert-dismissible fade show"
          role="alert"
        >
          <strong>Updated!</strong> Your information.
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="alert"
            aria-label="Close"
          ></button>
        </div>
      )}
      <div className="settings-inner-blk">
        <h3 className="text-center">SENIOR BRAG SHEET</h3>
        <h4 className="text-center">Letter of Recommendation Request</h4>
      </div>
      <div className="contact-info-container p-1">
        <form onSubmit={handleSubmit}>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr className="bg-primary text-white">
                  <th colSpan={4}>
                    <h4 className="text-center">Contact Info</h4>
                  </th>
                </tr>
              </thead>
              <thead>
                <tr className="bg-primary text-white">
                  <th>Name</th>
                  <th>Email</th>
                  <th>Grade</th>
                  <th>Deadline</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="form-control"
                      style={{
                        backgroundColor: "#CFE2F3",
                        borderColor: "#6FA8DC",
                      }}
                    />
                  </td>
                  <td>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="form-control"
                      style={{
                        backgroundColor: "#CFE2F3",
                        borderColor: "#6FA8DC",
                      }}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      value={grade}
                      onChange={(e) => setGrade(e.target.value)}
                      className="form-control"
                      style={{
                        backgroundColor: "#CFE2F3",
                        borderColor: "#6FA8DC",
                      }}
                    />
                  </td>
                  <td>
                    <input
                      type="date"
                      value={deadline}
                      onChange={(e) => setDeadline(e.target.value)}
                      className="form-control"
                      style={{
                        backgroundColor: "#CFE2F3",
                        borderColor: "#6FA8DC",
                      }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="mb-3">
            <label htmlFor="testScore" className="form-label fw-bold text-dark">
              Test Scores:
            </label>
            <textarea
              id="testScore"
              value={testScore}
              onChange={(e) => setTestScore(e.target.value)}
              rows="3"
              className="form-control"
              style={{ backgroundColor: "#CFE2F3", borderColor: "#6FA8DC" }}
            />
          </div>

          <div className="mb-3">
            <label
              htmlFor="extActivity"
              className="form-label fw-bold text-dark"
            >
              Extracurricular Activities:
            </label>
            <textarea
              id="extActivity"
              value={extActivity}
              onChange={(e) => setExtActivity(e.target.value)}
              rows="3"
              className="form-control"
              style={{ backgroundColor: "#CFE2F3", borderColor: "#6FA8DC" }}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="award" className="form-label fw-bold text-dark">
              Awards:
            </label>
            <textarea
              id="award"
              value={award}
              onChange={(e) => setAward(e.target.value)}
              rows="3"
              className="form-control"
              style={{ backgroundColor: "#CFE2F3", borderColor: "#6FA8DC" }}
            />
          </div>

          <div className="mb-3">
            <label
              htmlFor="threeAdjective"
              className="form-label fw-bold text-dark"
            >
              Character Traits: Three adjectives that describe me and why:
            </label>
            <textarea
              id="threeAdjective"
              value={threeAdjective}
              onChange={(e) => setThreeAdjective(e.target.value)}
              rows="3"
              className="form-control"
              style={{ backgroundColor: "#CFE2F3", borderColor: "#6FA8DC" }}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="hobby" className="form-label fw-bold text-dark">
              My hobbies, interests, and talents:
            </label>
            <textarea
              id="hobby"
              value={hobby}
              onChange={(e) => setHobby(e.target.value)}
              rows="3"
              className="form-control"
              style={{ backgroundColor: "#CFE2F3", borderColor: "#6FA8DC" }}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="mostProud" className="form-label fw-bold text-dark">
              What I&apos;m most proud of:
            </label>
            <textarea
              id="mostProud"
              value={mostProud}
              onChange={(e) => setMostProud(e.target.value)}
              rows="3"
              className="form-control"
              style={{ backgroundColor: "#CFE2F3", borderColor: "#6FA8DC" }}
            />
          </div>

          <div className="mb-3">
            <label
              htmlFor="strengWeakness"
              className="form-label fw-bold text-dark"
            >
              My strength and weaknesses:
            </label>
            <textarea
              id="strengWeakness"
              value={strengWeakness}
              onChange={(e) => setStrengWeakness(e.target.value)}
              rows="3"
              className="form-control"
              style={{ backgroundColor: "#CFE2F3", borderColor: "#6FA8DC" }}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="obstacle" className="form-label fw-bold text-dark">
              Specific to this class:
            </label>
            <textarea
              id="obstacle"
              value={obstacle}
              onChange={(e) => setObstacle(e.target.value)}
              rows="3"
              className="form-control"
              style={{ backgroundColor: "#CFE2F3", borderColor: "#6FA8DC" }}
            />
          </div>

          <div className="mb-3">
            <label
              htmlFor="recommendation"
              className="form-label fw-bold text-dark"
            >
              What I would include if I wrote your own recommendation:
            </label>
            <textarea
              id="recommendation"
              value={recommendation}
              onChange={(e) => setRecommendation(e.target.value)}
              rows="3"
              className="form-control"
              style={{ backgroundColor: "#CFE2F3", borderColor: "#6FA8DC" }}
            />
          </div>

          <button type="submit" className="btn btn-primary">
            Update BragSheet
          </button>
        </form>
      </div>
      {/* </div> */}
    </div>
  );
}
